module.exports = __webpack_public_path__ + "img/040-data.ae658fd8.png";